import config from '@/settings/config.js';
import _axios from './axios';
import { InitiatePayment, PaymentGateWay } from "@/types/CartTypes";

class PaymentService
{
    async initiatePayment(dto: InitiatePayment) : Promise<PaymentGateWay>
    {
       const prdt= await _axios.post<PaymentGateWay>(config.initiatePayment, dto);
       return prdt.data;
    }
}

export default new PaymentService();
